import { Button } from '@/components/ui/button'

export default function CTABanner({ title, description, buttonText, onButtonClick, imageSrc }) {
  return (
    <section className="relative overflow-hidden py-20 bg-primary text-primary-foreground">
      <div className="absolute inset-0 bg-black/20 z-0" />
      <div className="container relative z-10 mx-auto px-4 text-center">
        <div className="max-w-2xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">{title}</h2>
          <p className="text-lg opacity-90 mb-8">{description}</p>
          <Button size="lg" variant="secondary" onClick={onButtonClick}>{buttonText}</Button>
        </div>
        {imageSrc && <img src={imageSrc} alt="" className="absolute bottom-0 left-0 w-32 md:w-48 opacity-10 pointer-events-none" />}
      </div>
    </section>
  )
}